import { Link } from "react-router-dom";
import { ChevronRight, Inbox, MapPin } from "lucide-react";
import { fmtDate } from "@/lib/constants";
import { StatusBadge } from "@/components/StatusBadge";

export const ReferralList = ({ items }) => {
  if (!items.length)
    return (
      <div className="rounded-2xl border border-dashed border-[#C5CCC1] p-10 text-center text-sm text-[#75867E]" data-testid="referrals-empty">
        <Inbox className="mx-auto mb-3 h-8 w-8" /> Nessuna segnalazione ancora. Inizia dal modulo!
      </div>
    );
  return (
    <ul className="space-y-3" data-testid="my-referrals-list">
      {items.map((r) => (
        <li key={r.referral_id}>
          <Link to={`/segnalazioni/${r.referral_id}`} className="group flex items-center gap-4 rounded-2xl border border-[#E2E5DC] bg-white p-4 transition-colors hover:border-[#0F2D5E]/40" data-testid={`referral-item-${r.referral_id}`}>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <p className="truncate font-semibold">{r.lead_name}</p>
                <StatusBadge status={r.status} testId={`referral-status-${r.referral_id}`} />
              </div>
              <p className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-[#75867E]">
                <span>{r.category_name}</span>
                <span className="flex items-center gap-1"><MapPin className="h-3 w-3" />{r.lead_city}</span>
                <span className="font-mono">{fmtDate(r.created_at)}</span>
              </p>
            </div>
            <ChevronRight className="h-5 w-5 text-[#C5CCC1] transition-transform group-hover:translate-x-1 group-hover:text-[#0F2D5E]" />
          </Link>
        </li>
      ))}
    </ul>
  );
};
